import { useCallback, useMemo, useState } from 'react';

export const useLoading: (
  defaultState?: boolean,
) => {
  isLoading: boolean;
  toggleLoading: () => void | undefined;
} = (defaultState = false) => {
  const [isLoading, setIsLoading] = useState<boolean>(defaultState);

  const toggleLoading = useCallback((newState?: boolean) => {
    setIsLoading(loading => (newState !== undefined ? newState : !loading));
  }, []);

  return useMemo(() => ({ isLoading, toggleLoading }), [isLoading, toggleLoading]);
};
